import { isNativeMobile } from '@droplet-tech-code/core-elements/module/utils/utils.helper';

import { paginationUtil } from '~/components/FlatList/FlatList.Paginated';
import { PageHeader } from '~/components/Page/Page.Header';
import { translate } from '~/utils/translation.utils';

import { bookingApi } from '../Bookings.api';

export const BookingsListHeader = () => {
  const [invalidate, { isLoading }] =
    bookingApi.useInvalidateGetRecentBookingListMutation();

  return (
    <PageHeader
      title={translate('bookings.bookingsRecent')}
      withBack={isNativeMobile}
      iconRight={{
        color: 'monochrome',
        icon: 'refresh',
        onPress: () => {
          const options = paginationUtil.lastReq.BookingsRecent;
          const lastItemId = paginationUtil.lists.BookingsRecent;

          if (options) {
            invalidate({
              ...options,
              paginationRequest: {
                ...options.paginationRequest,
                lastItemId,
                refreshList: !!lastItemId,
              },
            });
          }
        },
        isLoading,
      }}
    />
  );
};
